var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxCircleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2892 55.5216L58.8559 31.9516L54.1426 27.2383L35.2892 46.0949L25.8592 36.665L21.1459 41.3783L35.2892 55.5216Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66675 40.0003C6.66675 21.5908 21.5906 6.66699 40.0001 6.66699C58.4096 6.66699 73.3334 21.5908 73.3334 40.0003C73.3334 58.4098 58.4096 73.3337 40.0001 73.3337C21.5906 73.3337 6.66675 58.4098 6.66675 40.0003ZM40.0001 66.667C25.2725 66.667 13.3334 54.7279 13.3334 40.0003C13.3334 25.2727 25.2725 13.3337 40.0001 13.3337C54.7277 13.3337 66.6668 25.2727 66.6668 40.0003C66.6668 54.7279 54.7277 66.667 40.0001 66.667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCircleOutlined);
export default __webpack_public_path__ + "static/media/checkbox-circle-outlined.06f1ee95ec65ce8b1147e3a24f4971c5.svg";
export { ForwardRef as ReactComponent };